import { Configuration, PageLayout } from "components";
import Segment, { SegmentContainer } from "components/atoms/Segment";
import { useParams } from "react-router-dom";

const ConfigurationPage = (props) => {
    const { configurationItem, itemAction, itemId, subItem } = useParams();
    return (
        <PageLayout
            border={false}
            mainContent={({ setBreadcrumbNavigationItems }) => {
                return (
                    <SegmentContainer>
                        <Segment shadow>
                            <Configuration
                                setBreadcrumbNavigationItems={setBreadcrumbNavigationItems}
                                activeItem={configurationItem}
                                itemAction={itemAction && itemAction.toLowerCase()}
                                itemId={itemId}
                                subItem={subItem}
                            ></Configuration>
                        </Segment>
                    </SegmentContainer>
                );
            }}
        ></PageLayout>
    );
};

export default ConfigurationPage;
